import React, { useState, useEffect, useContext, lazy, Suspense, useRef } from 'react';
import { Cookies } from '../index.js';
import axios from 'axios';
import { alert_error, alert_success } from '../AppContext';
import { GoogleOAuthProvider, useGoogleOneTapLogin, GoogleLogin } from '@react-oauth/google';
const App = ({ disabledbutton, setdisabledbutton, nutxuly, setnutxuly, buttonTextjop, setbuttonTextjop }) => {
    const [chedo, setchedo] = useState('');
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutxuly(0);
        if (status == 0) {
            alert_error(info.message);
            setbuttonTextjop('Xin lỗi vì sự cố bạn hãy thử lại nhé');
            //   captchaRef.current?.reset();
        }
        else if (status == 1) {
            var date = new Date();

            // Thêm 1 năm vào thời gian hiện tại
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000)); // 365 ngày * 24 giờ * 60 phút * 60 giây * 1000 miligiây

            // Đặt cookie với thời gian sống là 1 năm
            Cookies.set('apikey', info.apikey, { expires: date });
            alert_success(info.message);
            setbuttonTextjop('Hust Media cảm ơn bạn rất nhiều');
        }
        else {
            alert_error('Lỗi máy chủ vui lòng tải lại trang');
        }
        
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1500);
        }
    };

    const handleOptionChange = (credentialResponse) => {
        //   setcontent(selectedOptionok.category);
        const currentUrl = window.location.href;

        // Tạo một đối tượng URL từ URL hiện tại
        const url = new URL(currentUrl);
        setnutxuly(1);
        console.log(credentialResponse);
        const apikey = Cookies.get('apikey');
        const code_login = Cookies.get('code_login');
        const hustmediavipro = Cookies.get('hustmediavipro');
        const device_type =  url.searchParams.get('device_type');
        const domain = window.location.hostname;
        setbuttonTextjop('Bạn hãy đợi vài giây để app xử lý nhé');
        axios
            .post('https://hust.media/api/auth/login_google.php', {
                apikey: apikey,
                domain: domain,
                chedo: chedo,
                code_login: code_login,
                device_type: device_type,
                lienket: hustmediavipro,
                redirect: '/shop/content/blog_posts/freefltiktok/31',
                auth_google: credentialResponse,
            })
            .then(response => testFunction(response))
            .catch(error => {
                alert_error(error);
                setnutxuly(0);
            })
        // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
    }
    useEffect(() => {
        // Lấy giá trị của tham số "signupusername" từ URL
        // Lấy URL hiện tại
        const currentUrl = window.location.href;

        // Tạo một đối tượng URL từ URL hiện tại
        const url = new URL(currentUrl);

        // Lấy tham số 'chedo' từ URL
        const code_login = url.searchParams.get('code_login');
        if (code_login) {
            const expirationDate = new Date();
            expirationDate.setMinutes(expirationDate.getMinutes() + 15); // Thêm 15 phút
            Cookies.set('code_login', code_login, { expires: expirationDate });
        }
        const chedo_ok = url.searchParams.get('chedo');
        if (chedo_ok) {
            setchedo(chedo_ok);
        }
    },);

    useGoogleOneTapLogin({
        onSuccess: credentialResponse => {
            handleOptionChange(credentialResponse);
        },
        onError: () => {
            alert_error('Login Failed');
        },
    });
    return (
        <>
            <GoogleLogin
                buttonText="Đăng nhập Google"
                onSuccess={credentialResponse => {
                    handleOptionChange(credentialResponse);
                }}
                onError={() => {
                    console.log('Login Failed');
                }}
                useOneTap
            />
        </>
    );

};


const Login_google = ({ disabledbutton, setdisabledbutton, nutxuly, setnutxuly, buttonTextjop, setbuttonTextjop }) => {
    return (
        <div style={{ textAlign: "center" }} className="flex justify-center items-center ">
            <div className="max-w-lg mx-auto">
                <GoogleOAuthProvider clientId="28575489156-q3lam416p6444d4v4qu7ngiqrqr4ro94.apps.googleusercontent.com">
                    <App
                        disabledbutton={disabledbutton} setdisabledbutton={setdisabledbutton}
                        nutxuly={nutxuly} setnutxuly={setnutxuly}
                        buttonTextjop={buttonTextjop} setbuttonTextjop={setbuttonTextjop}
                    />
                </GoogleOAuthProvider>
            </div>
        </div>
    )
}

export default Login_google;